// extracted by mini-css-extract-plugin
module.exports = {"durationLargeIntro":"350","durationLargeOutro":"250","durationSmallIntro":"200","durationSmallOutro":"150","logo":"logo_logo__XurKE"};